export default "__VITE_ASSET__31abb6da__"